import { FieldContext } from "./chunk-57D4P5XD.js";
import { TextInput_default } from "./chunk-S5YAL2ST.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Field/Field.Input.tsx
import { forwardRef, useContext } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var DEFAULT_COMPONENT = TextInput_default;
var FIELD_INPUT_CLASSNAME_MAP = {};
var FieldInput = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      "aria-describedby": ariaDescribedBy,
      className
    } = _b,
    rest = __objRest(_b, ["as", "aria-describedby", "className"]);
  const Component = as || DEFAULT_COMPONENT;
  const {
    id,
    name,
    description,
    required,
    validation,
    validationMessage
  } = useContext(FieldContext);
  return /* @__PURE__ */jsx(Component, __spreadValues({
    ref,
    id,
    name,
    required,
    validation,
    "aria-invalid": validation === "error" ? "true" : void 0,
    "aria-errormessage": validation === "error" && validationMessage ? "".concat(id, "-validation") : void 0,
    "aria-describedby": clsx(ariaDescribedBy, {
      ["".concat(id, "-description")]: description,
      ["".concat(id, "-required")]: required,
      ["".concat(id, "-validation")]: validation !== "error" && validationMessage
    }),
    className: clsx("pd:field__input", className)
  }, rest));
});
var Field_Input_default = FieldInput;
export { FIELD_INPUT_CLASSNAME_MAP, Field_Input_default };